import { ReactElement } from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import Box from '@mui/material/Box';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Link from '@mui/material/Link';
import HomeIcon from '@mui/icons-material/Home';
import { BEM_NAME_ELEMENTS } from './_const';

/**
 * Breadcrumb navigation
 * @param {ReactElement[]} breadcrumbs breadcrumb list to display after HOME
 * @param {any} props
 * @returns {ReactElement} navigation breadcrumbs for User Access Review
 */
const PageWithBreadcrumbs = ({ breadcrumbs, sx = {}, ...props }) => {
	const history = useHistory();

	const currentPageStyles = {
		display: 'flex',
		alignItems: 'center',
		cursor: 'default',
	};

	const linkStyles = {
		...currentPageStyles,
		cursor: 'pointer',
	};

	return (
		<>
			<Box sx={{ pb: 3, ...sx }}>
				<Breadcrumbs maxItems={7} aria-label='breadcrumb'>
					<Link
						underline='hover'
						color='text.secondary'
						onClick={() => history.push('/index.html')}
						sx={{
							...linkStyles,
						}}
						id={`${BEM_NAME_ELEMENTS.VIEW_BREADCRUMBS}__${BEM_NAME_ELEMENTS.FIELD_LINK}--ims-home`}
					>
						<HomeIcon sx={{ mr: 0.5 }} fontSize='inherit' />
						IMS Home
					</Link>
					{breadcrumbs.map(breadcrumb => breadcrumb)}
				</Breadcrumbs>
			</Box>
			{props.children}
		</>
	);
};

PageWithBreadcrumbs.propTypes = {
	currentPageLabel: PropTypes.string,
	CurrentPageIcon: PropTypes.object,
	children: PropTypes.node,
};

export default PageWithBreadcrumbs;
